import { hapticFeedback } from "@tma.js/sdk";

export class ReferralController {
  notifySuccess(): void {
    hapticFeedback.notificationOccurred("success");
  }

  impact(): void {
    hapticFeedback.impactOccurred("medium");
  }

  selection(): void {
    hapticFeedback.selectionChanged();
  }
}
